// Zentrale Anbieterdaten für alle Rechtsseiten (Impressum, Datenschutz, AGB).
// Spiegelt die Verkäuferdaten aus backend/.env wider.
export const seller = {
  name: "Lucas Garrido",
  legalName: "Lucas Garrido (Einzelunternehmer)",
  street: "Pflügersgrundstraße 32-34",
  zip: "68169",
  city: "Mannheim",
  country: "Deutschland",
  email: "info@gruendio.de",
  brand: "Gründio",
  website: "gründio.de",
};

export const stand = "Juni 2026";
